import { render, staticRenderFns } from "./RemoveItemModal.vue?vue&type=template&id=0ebafc8e"
import script from "./RemoveItemModal.vue?vue&type=script&lang=js"
export * from "./RemoveItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports